import request from '../utils/request'
const serviceName = 'dftdstore/api'

export function listByPath(data) {
  return request({
    url:`/${serviceName}/de/dir/listByPath`,
    method:'get',
    data
  })
}

export function listById(url, data) {
  return request({
    url:`/${serviceName}/de/dir/listById/${url}`,
    method:'get',
    data
  })
}

export function getList(category) {
  var url
  if (category === '') {
    url = `/${serviceName}/td/template/list`
  } else {
    url = `/${serviceName}/td/template/list?category=${category}`
  }

  return request({
    url: url,
    method:'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/dftdStore.js